import fetch from "auth/FetchInterceptorAppManager";

const AppManagerService = {};

AppManagerService.getUserBranchList = function () {
  return fetch({
    url: "am/branch",
    method: "get",
  });
};

export default AppManagerService;
